import React from 'react';
import { Recycle } from 'lucide-react';
import { makeStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

//workstation tile in the workstation overview
export default function RecyclingWorkstationTile(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let boxShadow = ""
    let cursor = "";
    let disabled = false;
    let opacity = 1;
    if (props.active) {
        boxShadow = "0 0 7px " + FlagstoneTheme.palette.primary.main;
    }


    if (props.active === false && props.maximumSelected === true) {
        disabled = true;

        cursor = "not-allowed";
        opacity = "0.4";
    } else {
        cursor = "pointer";

    }

    return (
        <div className={classes.workstation} disabled={disabled} style={{ boxShadow: boxShadow, cursor: cursor, opacity: opacity }} onClick={() => !disabled ? props.activateRecyclingWorkstation(props.workstation.id) : ''}>
            <div className={classes.line}>
                {t("SCRAP")}
            </div>
            <div className={classes.lineId}>
                {props.workstation.code}
            </div>
            <div className={classes.cardIcon}>
                <Recycle size={80} absoluteStrokeWidth strokeWidth={3}></Recycle>
            </div>
            <div className={classes.checkboxContainer}>
                <div className={classes.checkboxDiv}>
                    <Checkbox
                        className={classes.checkBox}
                        disabled={disabled}
                        disableRipple
                        color="default"
                        checked={props.active}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                        onChange={() => props.activateRecyclingWorkstation(props.workstation.id)}
                    />
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "25px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px"
    },
    cardIcon: {
        textAlign: "center",
        paddingBottom: "8px"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },

    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },

    workstation: {
        width: "200px",
        height: "220px",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",

        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",

        // box-shadow: 0px 3px 15px rgba(0,0,0,0.1);
    },
    checkboxContainer: {
        width: "200px",
        textAlign: "center"
    },
    checkboxDiv: {
        width: "50px",
        marginLeft: "auto",
        marginRight: "auto"

    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        marginTop: "3px"
    },
    scrapButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        marginTop: "50px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    buttonContainer: {
        width: "100%",
        textAlign: "center",
        marginBottom: "50px"
    }
}));